/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link, StyleSheet, Text, View } from '@react-pdf/renderer';

import { PDF_COLORS, PDF_FONT_FAMILY } from './styles';

const styles = StyleSheet.create({
  text: {
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 400,
    fontSize: 8,
    color: PDF_COLORS.textSecondary,
    maxWidth: 460,
  },
  flex: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    bottom: 24,
    left: 30,
    right: 30,
  },
  textStack: {
    flexDirection: 'column',
    gap: 2,
  },
  link: {
    color: PDF_COLORS.link,
    textDecoration: 'none',
  },
  pageNumber: {
    fontFamily: PDF_FONT_FAMILY,
    fontWeight: 500,
    fontSize: 8,
    color: PDF_COLORS.textSecondary,
  },
});

const Footer = () => (
  <View style={styles.flex} fixed>
    <View style={styles.textStack}>
      <Text style={styles.text}>
        QuoIntelligence GmbH (DE) | QuoIntelligence SRL (IT) | QuoIntelligence SLU (ES)
      </Text>
      <Text style={styles.text}>
        <Link src="mailto:curious@quointelligence.eu" style={styles.link}>
          curious@quointelligence.eu
        </Link>{' '}
        |{' '}
        <Link src="https://quointelligence.eu" style={styles.link}>
          quointelligence.eu
        </Link>
      </Text>
    </View>
    <Text
      style={styles.pageNumber}
      render={({ pageNumber, totalPages }) => `${pageNumber} | ${totalPages}`}
    />
  </View>
);

export default Footer;
